import { IconButton, useToast } from "@design";
import { Copy } from "lucide-react";
import { useTranslation } from "react-i18next";

/** Monospace value with a copy-to-clipboard button. */
export function CopyValue({ value, label, secret }: Readonly<{ value: string; label: string; secret?: boolean }>) {
  const { t } = useTranslation("common");
  const toast = useToast();
  return (
    <div className="flex min-w-0 items-center gap-1">
      <code
        className={`min-w-0 flex-1 truncate [font:var(--type-code)] ${secret ? "rounded-lg border border-border-input bg-surface-secondary px-3 py-2 text-success-on-subtle" : "text-content-secondary"}`}
      >
        {value}
      </code>
      <IconButton
        icon={<Copy />}
        aria-label={t("copy.action", { label })}
        variant="ghost"
        size="sm"
        onClick={() => {
          void navigator.clipboard.writeText(value);
          toast.success(t("copy.done", { label }));
        }}
      />
    </div>
  );
}
